export default __webpack_public_path__ + "static/media/blog1_3.e986fb23.png";